import { SearchfaqPipe } from './searchfaq.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchPipe } from './search.pipe';
import { SearchBoutiquePipe } from './search-boutique.pipe';
import { SearchmarchandPipe } from './searchmarchand.pipe';
import { SearchhistoriquePipe } from './searchhistorique.pipe';
import { FindBookmarkPipe } from './find-bookmark.pipe';
import { FindRevendeurPipe } from './find-revendeur.pipe';



@NgModule({
  declarations: [SearchPipe, SearchBoutiquePipe, SearchmarchandPipe, SearchhistoriquePipe, SearchfaqPipe, FindBookmarkPipe, FindRevendeurPipe],
  imports: [
    CommonModule
  ],
  exports: [
    SearchPipe, 
    SearchBoutiquePipe,
    SearchmarchandPipe,
    SearchhistoriquePipe,
    SearchfaqPipe,
    FindBookmarkPipe,
    FindRevendeurPipe,
  ]
})
export class SharedModule { }
